import { useCallback } from 'react';
import { atomUserValues, type ExperimentalGroup } from './user.atom';
import { useSetAtom } from 'jotai';

export const useUserAtom = () => {
  const setAtomUserValues = useSetAtom(atomUserValues);

  const setUserAtomExperimentalGroups = useCallback(
    (expGroupsArray: Array<string>) => {
      const nextExperimentalGroups = expGroupsArray.reduce<
        Record<`EXP${number}`, ExperimentalGroup>
      >((acc, cur) => {
        const item = cur.split(':');
        return {
          ...acc,
          [item[0]]: item[1],
        };
      }, {});
      setAtomUserValues(prev => ({
        ...prev,
        experimentalGroups: nextExperimentalGroups,
      }));
    },
    [setAtomUserValues],
  );

  return { setUserAtomExperimentalGroups };
};
